import { createSlice } from "@reduxjs/toolkit";

// Function to load state from localStorage
const loadState = () => {
  try {
    const savedState = localStorage.getItem("donationState");
    return savedState ? JSON.parse(savedState) : undefined;
  } catch (error) {
    console.error("Failed to load state from localStorage", error);
    return undefined;
  }
};

// Default initial state
const defaultState = {
  amount: "",
  schedule: "One-time",
  donorType: "Individual",
};

// Merge localStorage state with default state
const initialState = loadState() || defaultState;

const donationSlice = createSlice({
  name: "donation",
  initialState,
  reducers: {
    setAmount: (state, action) => {
      state.amount = action.payload;
      localStorage.setItem("donationState", JSON.stringify(state));
    },
    setSchedule: (state, action) => {
      state.schedule = action.payload;
      localStorage.setItem("donationState", JSON.stringify(state));
    },
    setDonorType: (state, action) => {
      state.donorType = action.payload;
      localStorage.setItem("donationState", JSON.stringify(state));
    },
    resetDonationState: (state) => {
      Object.assign(state, defaultState);
      localStorage.setItem("donationState", JSON.stringify(defaultState));
    },
  },
});

export const { setAmount, setSchedule, setDonorType, resetDonationState } = donationSlice.actions;
export default donationSlice.reducer;
